import { useContext } from 'react'
import { Link } from 'react-router-dom'

import AdminLayout from '@/components/admin-layout'
import UserContext from '@/context/users'
import { useStores } from '@/stores/RootStoreContext'
import { ModalEnum } from '@/interfaces'

import { useDashboardHome } from './hooks/useDashboardHome'
import { useUsageGraph } from './hooks/useUsageGraph'
import { useClientHealth } from './hooks/useClientHealth'

import Skeleton from './components/Skeleton'
import PlanLimitsGrid from './sections/PlanLimitsGrid'
import UsageChart from './sections/UsageChart'
import LearningFeed from './sections/LearningFeed'
import SetupActions from './sections/SetupActions'
import ClientHealth from './sections/ClientHealth'

export default function DashboardNew() {
  const [user] = useContext(UserContext)
  const { modalStore } = useStores()

  const { home, loading: homeLoading } = useDashboardHome()
  const usage = useUsageGraph()
  const { health, loading: healthLoading } = useClientHealth()

  const onUpgrade = () => modalStore.openModal(ModalEnum.UPGRADE_PLAN)

  const companyName = user?.company?.name ?? '—'
  const planName = home?.company?.assistantPlan?.name ?? '—'

  return (
    <AdminLayout withBackground={false} noPadding>
      <div
        className="dash-scroll h-full w-full overflow-y-auto"
        style={{ background: 'var(--dash-bg)' }}
      >
        <div className="mx-auto flex w-full max-w-[1400px] flex-col gap-6 px-6 py-8">
          <header className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
            <div>
              <h1
                className="text-2xl font-semibold tracking-tight"
                style={{ color: 'var(--dash-text)' }}
              >
                Central de clientes
              </h1>
              {homeLoading ? (
                <div className="mt-2 flex items-center gap-2">
                  <Skeleton className="h-3.5 w-28" />
                  <span
                    className="text-xs"
                    style={{ color: 'var(--dash-text-faint)' }}
                  >
                    ·
                  </span>
                  <Skeleton className="h-3.5 w-20" />
                </div>
              ) : (
                <p
                  className="mt-1.5 text-xs"
                  style={{ color: 'var(--dash-text-muted)' }}
                >
                  {companyName}
                  <span
                    className="mx-2"
                    style={{ color: 'var(--dash-text-faint)' }}
                  >
                    ·
                  </span>
                  Plano {planName}
                </p>
              )}
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <Link
                to="/client-platforms"
                className="inline-flex items-center px-4 py-2 text-xs font-medium transition-colors"
                style={{
                  borderRadius: 'var(--dash-radius)',
                  border: '1px solid var(--dash-border-strong)',
                  background: 'var(--dash-surface)',
                  color: 'var(--dash-text-soft)',
                }}
              >
                Ver clientes
              </Link>
            </div>
          </header>

          <SetupActions />

          <ClientHealth health={health} loading={healthLoading} />

          <PlanLimitsGrid home={home} loading={homeLoading} onUpgrade={onUpgrade} />

          <LearningFeed posts={home?.posts} loading={homeLoading} />

          <UsageChart {...usage} />

        </div>
      </div>
    </AdminLayout>
  )
}
